import greenCheck from '../../../assets/icons/circle_check_green.svg'
import error_outline from '../../../assets/icons/error_outline.svg'
import close from '../../../assets/icons/close.svg'
import { Button, Modal } from 'syngenta-react-components'
import CloseButton from '../../../components/subComponents/CloseButton'

export const LoadingModal = ({ showModal }) => {
  return (
    <div className="modalContainer" style={{ display: showModal ? 'block' : 'none' }}>
      <div className="aHModalChild posr t100" style={{ 'maxWidth': '900px' }}>
        <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div className='bb1-s-lightgray df jcsb'>
            <div className='df ml15 mt15 mb15'>
              <div className='loader h30 w30' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export const SuccessModal = ({ showModal, setShowModal, text }) => {
  const handleClose = () => {
    setShowModal(false)
  }
  return (
    <div className="modalContainer" style={{ display: showModal ? 'block' : 'none' }}>
      <div className="aHModalChild posr t100" style={{ 'maxWidth': '800px' }}>
        <div className='w120% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
          <div className='bb1-s-lightgray df jcsb ' style={{ display: 'flex', justifyContent: 'center' }}>
            <div className='df jcc p20' >
              <img src={greenCheck}
                alt='success icon'>
              </img>
              <div className='ml10'>
                {text}
              </div>
            </div>
          </div>
          <div className='bt1-s-lightgray df aic jcfe'>
            <div className='mt8 mb8 mr8'>
              <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={handleClose} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export const WarningModal = ({ showModal, setShowModal, numberOfIssues, arrOfMissingRequiredVal, arrOfDupVals }) => {
  const handleClose = () => {
    setShowModal(false)
  }
  const createList = arr => {
    return arr.map((obj, index) => {
      return (
        <span key={`${index}`}>{`${obj} `}</span>
      )
    })
  }

  const createMissingValuesList = arr => {
    return (
      <div>
        {arr.map((missingValue, index) => {
          return (
            <div className='df' key={`${index}`}>
              <span className='mr24'>
                {missingValue.index}
              </span>
              <div>
                {missingValue.whatIsMissing.map((val, indexKey) => { return <span className='ml8' key={`${indexKey}`}>{`${val}${index + 1 === missingValue.whatIsMissing.length ? '' : ','}`}</span> })}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <Modal
      autoHeight
      show={showModal}
      handleClose={() => setShowModal(false)}
    >
      <div className="modalContainer" style={{ display: showModal ? 'block' : 'none' }}>
        <div className="aHModalChild posr t100" style={{ 'maxWidth': '900px' }}>
          <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
            <div className='bb1-s-lightgray df jcsb'>
              <div className='df ml15 mt15 mb15'>
                <img src={error_outline}
                  alt='error icon'>
                </img>
                <div className='ml10'>
                  {`Review Upload Issue${numberOfIssues > 1 ? 's' : ''}`}
                </div>
              </div>
              <CloseButton closeAction={handleClose} src={close} />
            </div>
            <div className='p15'>
              <div>
                <span className='fw600'>{numberOfIssues}</span>
                <span>
                  {` issue${numberOfIssues > 1 ? 's' : ''} found. Edit and reupload the corrected source file in order to save. See below for list of identified row${numberOfIssues > 1 ? 's' : ''}.`}
                </span>
                {arrOfMissingRequiredVal?.length ?
                  <>
                    <div className='fw600 mt25 mb10'>{`MISSING REQUIRED DATA FIELD${arrOfMissingRequiredVal.length > 1 ? 'S' : ''}`}</div>
                    {createMissingValuesList(arrOfMissingRequiredVal)}
                  </> : null
                }
                {arrOfDupVals?.length ?
                  <>
                    <div className='fw600 mt25 mb10'>{`Duplicate${arrOfDupVals.length > 1 ? 's' : ''} Entries Found. Please Retry`}</div>
                    <div>
                      {createList(arrOfDupVals)}
                    </div>
                  </> : null
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}


export const WrongFormatModal = ({ showModal, setShowModal, notFoundEmail, notFoundResellerSapId }) => {
  const handleClose = () => {
    setShowModal(false)
  }

  const createList = arr => {
    return arr.map((obj, index) => {
      return <div key={index}> {obj.slice(2)} </div>
    })
  }

  const createMissingValuesList = arr => {
    return (
      <div>
        {arr.map((missingValue, index) => {
          return (
            <div className='df' key={`${index}`}>
              <span className='mr24'> {missingValue} </span>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className="modalContainer" style={{ display: showModal ? 'block' : 'none' }}>
      <div className="aHModalChild posr t100" style={{ 'maxWidth': '900px' }}>
        <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
          <div className='bb1-s-lightgray df jcsb' >
            <div className='df ml15 mt15 mb15'>
              <img src={error_outline}
                alt='error icon'>
              </img>
              <div className='ml10'>
                {'These record\'s not found'}
              </div>
            </div>
            <CloseButton closeAction={handleClose} src={close} />
          </div>
          <div className='p15'>
            <div>
              {notFoundEmail?.length ?
                <>
                  <div className='fw600 mt5 mb10'>{`Email${notFoundEmail.length > 1 ? '\'s' : ''} `}</div>
                  {createMissingValuesList(notFoundEmail)}
                </> : null
              }
              {notFoundResellerSapId?.length ?
                <>
                  <div className='fw600 mt5 mb10'>{`Reseller SAP ID ${notFoundResellerSapId.length > 1 ? 's' : ''}`}</div>
                  <div>
                    {createList(notFoundResellerSapId)}
                  </div>
                </> : null
              }
            </div>
          </div>
          <div className='bt1-s-lightgray df aic jcfe'>
            <div className='mt8 mb8 mr8'>
              <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={handleClose} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export const ServerErrorModal = ({ showModal, setShowModal }) => {
  const handleClose = () => {
    setShowModal(false)
  }
  return (
    <div className="modalContainer" style={{ display: showModal ? 'block' : 'none' }}>
      <div className="aHModalChild posr t100" style={{ 'maxWidth': '900px' }}>
        <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
          <div className='bb1-s-lightgray df jcsb' >
            <div className='df ml15 mt15 mb15'>
              <img src={error_outline}
                alt='error icon'>
              </img>
              <div className='p15'>
                {'Whoops! Something is not working quite right. Please contact your admin'}
              </div>
            </div>
          </div>
          <div className='bt1-s-lightgray df aic jcfe'>
            <div className='mt8 mb8 mr8'>
              <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={handleClose} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const FailedAssignmentModal = ({ showModal, setShowModal, assignments }) => {

  const handleClose = () => {
    setShowModal(false)
  }

  const createMissingValuesList = arr => {
    return (
      <div>
        {arr.map((missingValue, index) => {
          return (
            <div className='df' key={`${index}`} style={{ display: 'flex', gap: '40px' }}>
              <span className='w200'> {missingValue.reseller_sap_id}</span>
              <span> {missingValue.new_account_lead_email} </span>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className="modalContainer" style={{ display: showModal ? 'block' : 'none' }}>
      <div className="aHModalChild posr t100" style={{ 'maxWidth': '900px' }}>
        <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
          <div className='bb1-s-lightgray df jcsb' >
            <div className='df ml15 mt15 mb15'>
              <img src={error_outline}
                alt='error icon'>
              </img>
              <div className='ml10'>
                {'Failure Account Lead list'}
              </div>
            </div>
            <CloseButton closeAction={handleClose} src={close} />
          </div>
          <div className='p15'>
            <div>
              {assignments?.length ?
                <>
                  <div className='fw600 mt5 mb10' style={{ display: 'flex', gap: '40px' }}>
                    <span className='w200'>{` Reseller SAP ID${assignments.length > 1 ? '\'s' : ''}  `}</span>
                    <span>{`New Account Lead Email${assignments.length > 1 ? '\'s' : ''} `}</span></div>
                  {createMissingValuesList(assignments)}
                </> : null
              }

            </div>
          </div>
          <div className='bt1-s-lightgray df aic jcfe'>
            <div className='mt8 mb8 mr8'>
              <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={handleClose} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}